import getQuery from '~/cache/query/get';

export default {
	resolvers: {
		Query: {
			stripeModal: () => ({
				upgradeModalData: {
					isOpen: false,
					upgradeType: null,
					period: null,
					plan: null,
					salesVariant: null,
					iframeProps: null,
					saleSource: null,
					__typename: 'StripeUpgradeModalData',
				},
				__typename: 'StripeUpgradeModal',
			}),
		},
		Mutation: {
			setUpgradeModal: (_, input, { cache }) => {
				cache.writeQuery({
					query: getQuery('stripeModal'),
					data: {
						stripeModal: {
							upgradeModalData: {
								...input,
								__typename: 'StripeUpgradeModalData',
							},
							__typename: 'StripeUpgradeModal',
						},
					},
				});
				return true;
			},
		},
	},
};
